/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A per-claim auto-import rule (watched email address or subject term)
 * @export
 * @interface EmailMatchRule
 */
export interface EmailMatchRule {
    /**
     * 
     * @type {number}
     * @memberof EmailMatchRule
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof EmailMatchRule
     */
    claimId: number;
    /**
     * email = matched as sender/recipient address; subject = matched as a quoted subject phrase
     * @type {string}
     * @memberof EmailMatchRule
     */
    ruleType: EmailMatchRuleRuleTypeEnum;
    /**
     * The watched email address or subject term
     * @type {string}
     * @memberof EmailMatchRule
     */
    value: string;
    /**
     * 
     * @type {number}
     * @memberof EmailMatchRule
     */
    createdBy?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmailMatchRule
     */
    createdAt: Date;
}


/**
 * @export
 */
export const EmailMatchRuleRuleTypeEnum = {
    Email: 'email',
    Subject: 'subject'
} as const;
export type EmailMatchRuleRuleTypeEnum = typeof EmailMatchRuleRuleTypeEnum[keyof typeof EmailMatchRuleRuleTypeEnum];


/**
 * Check if a given object implements the EmailMatchRule interface.
 */
export function instanceOfEmailMatchRule(value: object): value is EmailMatchRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('ruleType' in value) || value['ruleType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function EmailMatchRuleFromJSON(json: any): EmailMatchRule {
    return EmailMatchRuleFromJSONTyped(json, false);
}

export function EmailMatchRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailMatchRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'ruleType': json['ruleType'],
        'value': json['value'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function EmailMatchRuleToJSON(json: any): EmailMatchRule {
    return EmailMatchRuleToJSONTyped(json, false);
}

export function EmailMatchRuleToJSONTyped(value?: EmailMatchRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'ruleType': value['ruleType'],
        'value': value['value'],
        'createdBy': value['createdBy'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

